export interface InvoiceTemplateClass {
    AccountInvoiceTemplateId: string
    AccountId: number
    AccountInvoiceTemplateName: string
    AccountName: string
    Address1: string
    Address2: string
    ZipCode: string
    State: string
    City: string
    CountryId: number
    EMailAddress: string
    Telephone: string
    Fax: string
    InvoiceFooter:string
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    IsDisabled: boolean
    IsDeleted: boolean
    search: string;
    pageNo: number;
    pageSize: number;
}
const common = {    
    AccountName:"",
    AccountInvoiceTemplateName: "",
    Address1:"",
    Address2:"",
    ZipCode:"",
    State:"",
    City:"",
    CountryId:0,
    EMailAddress:"",
    Telephone:"",
    Fax:"",
    InvoiceFooter:"",
    IsDisabled:false
  };

  
  export const InvoiceTemplateInitialsForAdd = { ...common };
  
  export const InvoiceTemplateInitialsForUpdate = {
    ...common,
    AccountInvoiceTemplateId: 0
  };